import { LoadingButton } from '@mui/lab';
import { Stack, TextField, Grid, Box } from '@mui/material';
import { Input } from 'src/@/components/ui/input';
import { ButtonLoading } from 'src/@/components/use/ButtonLoading';
import InputStyle from 'src/components/InputStyle';
import { RowInput } from 'src/components/forms/RowInput';


export default function PerfilAlterarSenha({
  isSubmitting,
  password,
  repeatPassword,
  changePassword,
  changeRepeatPassword,
  submit
}) {
  return (

      <div className='flex flex-col gap-6'>
          <Stack direction={"row"} spacing={2}>
            <RowInput
              label="Senha"
              input={<Input
                value={password}
                type="password"
                onChange={changePassword}
              />}
            />

            <RowInput
              label="Confirmar Senha"
              input={<Input
                value={repeatPassword}
                type="password"
                onChange={changeRepeatPassword}
              />}
            />
          </Stack>
          <ButtonLoading className="w-[200px] bg-slate-700" onClick={submit} loading={isSubmitting}>
            Salvar
          </ButtonLoading>
      </div>

  );
}
